<template>
  <li class="flow-obj">
    <img @click="$emit('select', index)"
      class="icon" :src="icon[innerValue['@call']]" />
    <div class="sub-code-area">
      <div class="sub-code" v-for="s in subCode[innerValue['@call']]" :key="s.value">
        <div class="sub-code-header">
          {{ s.label }}
        </div>
        <div class="sub-code-body">
          <draggable
            tag="ul" :list="innerValue.arguments[s.value]" :group="{name:'code'}">
            <flow-icon v-for="(c,i) in innerValue.arguments[s.value]" :key="`code${index}-${s.value}-${i}`"
              :class="{ active: currentCodeIndex == i }"
              @select="$emit('select', $event)"
              v-model="innerValue.arguments[s.value][i]" :index="`${index}.arguments[${s.value}][${i}]`" />
          </draggable>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import draggable from 'vuedraggable'
import { iconKey,componentSubCode } from './mixin-cmd'
export default {
  name: 'flow-icon',
  props: {
    value: Object,
    index: String,
  },
  components: {
    draggable 
  },
  computed: {
    icon () { return iconKey },
    subCode () { return componentSubCode }
  },
  data () {
    return {
      currentCodeIndex: null,
      innerValue: this.value
    }
  },
  watch: {
    value (v) {
      this.innerValue = v
    },
    innerValue (v) {
      this.$emit('input', v)
    }
  }
}
</script>

<style lang="scss" scoped>
.flow-obj {
  margin: 2px;
  outline: 1px dashed;
  display: flex;

  .icon {
    width: 32px;
    height: 32px;
    cursor: pointer;
    
    &:hover {
      background-color: #CCC;
    }
  }

  .sub-code-area {
    padding: 10px;

    .sub-code{
      outline: 1px solid;

      .sub-code-header {
        background-color: #555;
        color: #FFF;
      }
      .sub-code-body ul{
        min-height: 32px;
        padding-left: 0;
        padding-bottom: 20px;
      }
    }
  }
}
</style>